/**
 * Pure H OS · Phase D Wave 4 · Analytics (types + live view).
 * MongoDB collection: `pureh_analytics`.
 */
import { liveArray } from "../services/store";

export type AnalyticsKind = "dashboard" | "deep-dive" | "adhoc";
export type AnalyticsStatus = "live" | "archived";

export type AnalyticsBoard = {
  id: string;
  title: string;
  category: string;
  kind: AnalyticsKind;
  owner: string;
  refreshRelative: string;
  kpiCount: number;
  status: AnalyticsStatus;
};

export const ANALYTICS: AnalyticsBoard[] = liveArray<AnalyticsBoard>("analytics");
